<template>
  <div class="col-12">

    <div class=" row text-center ml-5">
      <h3 class="ui inverted purple text"><strong>Select Currency</strong>
      </h3>
      <p class="text-muted fw-light mt-4">Please note every account creation request made on this platform requires a
        deposit through EcoCash.</p>
    </div>

    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-9">

        <div class="row mb-5">
          <div class="col-sm-6 mb-3">
            <div class="card card-shadow">
              <div class="card-body">
                <h4 class="card-title"><strong>ZiG</strong></h4>
                <p class="card-text text-muted fw-light">Zimbabwean Dollar denominated account</p>
                <button class="ui purple right floated  button" @click="zig()">
                  Next
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-6 mb-3">
            <div class="card card-shadow">
              <div class="card-body">
                <h4 class="card-title"><strong>USD</strong></h4>
                <p class="card-text text-muted fw-light">United States Dollar denominated account</p>
                <button class="ui purple right floated button" @click="usd()">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5">
          <button @click="back()" class="ui grey button fluid">Back</button>
        </div>

      </div>
    </div>


  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { useAccountOpeningStore } from '@/stores/accountOpening';

export default {
  name: "CurrencyType",
  setup() {
    const accountOpeningStore = useAccountOpeningStore();
    return { accountOpeningStore };
  },
  data() {
    return { accounts: [], };
  },
  mounted() {
  },
  methods: {
    back() {
      this.$router.push("/account-opening/account-type");
    },
    zig() {
      this.setCurrencyType("ZiG");
      this.$router.push("/account-opening/current-customer-details");
    },
    usd() {
      this.setCurrencyType("USD");
      this.$router.push("/account-opening/current-customer-details");
    },
    // zig() {

    //   this.get(URLS.accounts + '/active-accounts', false)
    //     .then(res => {
    //       this.accounts = res.body;

    //       let getItems = this.accounts.filter((item) => {
    //         return (item.accountType === 'T24' && item.currency === 'ZiG')
    //       })
    //       console.log(getItems.length);
    //       if (getItems.length > 0) {
    //         this.$router.push("/account-opening/t24-account-failed");
    //       }
    //       else {
    //         localStorage.setItem("currency-type", "ZiG");
    //         this.$router.push("/account-opening/current-customer-details");
    //       }

    //       if (!res) return;
    //       if (res.errors) return this.errors = res.errors;

    //     })

    //   // Count occurrences
    //   const count = filteredData.length;

    //   if (count > 0) {
    //     this.$router.push("/account-opening/t24-account-failed");
    //   }
    //   else {
    //     localStorage.setItem("currency-type", "ZWL");
    //     this.$router.push("/account-opening/current-customer-details");
    //   }
    // },
    // usd() {
    //   // Retrieve data from local storage
    //   const storedData = localStorage.getItem('active_account_types');
    //   const accountTypesWithCurrency = JSON.parse(storedData) || [];

    //   // Filter by account type 'T24' and currency 'USD'
    //   const filteredData = accountTypesWithCurrency.filter(account => {
    //     return account.accountType === 'T24' && account.currencyType === 'USD';
    //   });

    //   // Count occurrences
    //   const count = filteredData.length;

    //   if (count > 0) {
    //     this.$router.push("/account-opening/t24-account-failed");
    //   }
    //   else {
    //     localStorage.setItem("currency-type", "ZWL");
    //     this.$router.push("/account-opening/current-customer-details");
    //   }
    // },
    submitForm() { },
    setCurrencyType(type) { this.accountOpeningStore.setCurrencyType(type); },
    ...baseMethods,
  }
};
</script>